import mergeProps from '@/utils/mergeProps';
import { StandaloneBanner } from 'base/components/Banner';

const HantStandaloneBanner: typeof StandaloneBanner = (props) => {
  return <StandaloneBanner {...mergeProps({ options: { $button: { colors: 'secondary' } } }, props)} />;
};

export default HantStandaloneBanner;
